import { putApiFactsAboutScaffolding } from "../../../../../api/generated/endpoints/facts-about-scaffolding/facts-about-scaffolding";
import { putApiFactsAboutWeatherProtection } from "../../../../../api/generated/endpoints/facts-about-weather-protection/facts-about-weather-protection";
import { putApiPlanForConduct } from "../../../../../api/generated/endpoints/plan-for-conduct/plan-for-conduct";
import { putApiRescueplan } from "../../../../../api/generated/endpoints/rescue-plan/rescue-plan";
import { putApiRiskAssesment } from "../../../../../api/generated/endpoints/risk-assesment/risk-assesment";
import { putApiSelfControlContainer } from "../../../../../api/generated/endpoints/self-control-container/self-control-container";
import { putApiSelfControlWeatherProtectionContainer } from "../../../../../api/generated/endpoints/self-control-weather-protection/self-control-weather-protection";
import type {
  FactsAboutScaffoldingDto as FactsAboutScaffolding,
  RescuePlanDto as RescuePlanModel,
  SelfControlContainerDto as SelfControlContainerModel,
  PlanForConductDto as PlanForConduct,
  RiskAssesmentContainerDto as RiskAssesmentContainer,
  FactsAboutWeatherProtectionDto as FactsAboutWeatherProtection,
  SelfControlWeatherProtectionContainerDto as SelfControlWeatherProtectionContainerModel
} from "../../../../../api/generated/model";
import { toastError } from "../../../../../utilities/messageUtils";

type CompletionResponse = { isComplete?: boolean } | undefined;

const applyBackendCompletion = (
  response: CompletionResponse,
  setCompletionStatus: (value: boolean) => void,
): boolean => {
  const isComplete = response?.isComplete === true;
  setCompletionStatus(isComplete);
  return isComplete;
};

export const handleSelfControlDataUpdate = async (controlContainerModel: SelfControlContainerModel | undefined, setSelfControlCompletionStatus: (value: boolean) => void): Promise<boolean> => {
  try {
    if (controlContainerModel) {
      const response = await putApiSelfControlContainer(controlContainerModel);
      return applyBackendCompletion(response, setSelfControlCompletionStatus);
    }
    else {
      throw new Error("SelfControlContainer is undefiend");
    }
  } catch (error) {
    toastError("Kunde inte spara egenkontroll ställning", error);
    throw error;
  }
}

export const handleFactAboutScaffoldingDataUpdate = async (factAboutScaffoldingModel: FactsAboutScaffolding | undefined, setFactAboutScaffoldingCompletionStatus: (value: boolean) => void): Promise<boolean> => {
  try {
    if (factAboutScaffoldingModel) {
      const response = await putApiFactsAboutScaffolding(factAboutScaffoldingModel);
      return applyBackendCompletion(response, setFactAboutScaffoldingCompletionStatus);
    }
    else {
      throw new Error("factAboutScaffolding is undefiend");
    }
  } catch (error) {
    toastError("Kunde inte spara fakta om ställning", error);
    throw error;
  }
}

export const handleRescuePlanDataUpdate = async (
  rescuePlanModel: RescuePlanModel | undefined,
  setRescuePlanCompletionStatus: (value: boolean) => void,
): Promise<boolean> => {
  try {
    if (rescuePlanModel) {
      const response = await putApiRescueplan(rescuePlanModel);
      return applyBackendCompletion(response, setRescuePlanCompletionStatus);
    }
    else {
      throw new Error("RescuePlan is undefiend");
    }
  } catch (error) {
    toastError("Kunde inte spara räddningsplan", error);
    throw error;
  }

}
export const handlePlanForConductDataUpdate = async (
  planForConduct: PlanForConduct | undefined,
  setPlanForConductCompletionStatus: (value: boolean) => void,
): Promise<boolean> => {
  try {
    if (planForConduct) {
      const response = await putApiPlanForConduct(planForConduct);
      return applyBackendCompletion(response, setPlanForConductCompletionStatus);
    }
    else {
      throw new Error("PlanForConduct is undefiend");
    }
  } catch (error) {
    toastError("Kunde inte spara plan för uppförande", error);
    throw error;
  }
}
export const handleRiskAssesmentDataUpdate = async (
  riskAssesmentContainer: RiskAssesmentContainer | undefined,
  workerView: boolean = false,
): Promise<RiskAssesmentContainer> => {
  try {
    if (riskAssesmentContainer) {
      return await putApiRiskAssesment({
        ...riskAssesmentContainer,
        savedAsWorker: workerView,
      });
    }
    else {
      throw new Error("RiskAssesmentContainer is undefiend");
    }
  } catch (error) {
    toastError("Kunde inte spara riskanalys", error);
    throw error;
  }
}

export const handleFactsWeatherProtectionDataUpdate = async (factsAboutWeatherProtectionModel: FactsAboutWeatherProtection | null | undefined, setFactsWeatherProtectionCompletionStatus: (value: boolean) => void): Promise<boolean> => {
  try {
    if (factsAboutWeatherProtectionModel) {
      const response = await putApiFactsAboutWeatherProtection(factsAboutWeatherProtectionModel);
      return applyBackendCompletion(response, setFactsWeatherProtectionCompletionStatus);
    }
    else {
      throw new Error("factWeatherProtection is undefiend");
    }
  } catch (error) {
    toastError("Kunde inte spara fakta om väderskydd", error);
    throw error;
  }
}

export const handleSelfControlWeatherProtectionDataUpdate = async (selfcontrolWeatherProtectionContainerModel: SelfControlWeatherProtectionContainerModel | null | undefined, setSelfControlWeatherProtectionCompletionStatus: (value: boolean) => void): Promise<boolean> => {
  try {
    if (selfcontrolWeatherProtectionContainerModel) {
      const response = await putApiSelfControlWeatherProtectionContainer(selfcontrolWeatherProtectionContainerModel);
      return applyBackendCompletion(response, setSelfControlWeatherProtectionCompletionStatus);
    }
    else {
      throw new Error("SelfControlWeatherProtectionContainer is undefiend");
    }
  } catch (error) {
    toastError("Kunde inte spara egenkontroll väderskydd", error);
    throw error;
  }
}
